import { useChatContext } from '@/chat/ChatContext';
import { EMERGENCY_LABELS, EMERGENCY_TEL } from '@/i18n/maps';
import { ChipAwareMarkdown } from '@/markdown/chips';
import type { EmergencyCTASection } from '@/types/chat';

export function EmergencyCtaView({ section }: { section: EmergencyCTASection }): JSX.Element {
  const { locale } = useChatContext();
  const numbers = (section.numbers ?? []).filter(
    (number) => Boolean(EMERGENCY_LABELS[number] && EMERGENCY_TEL[number]),
  );
  return (
    <section className="tw-text-[14px] tw-text-cal-emergency tw-leading-relaxed" role="alert">
      <ChipAwareMarkdown
        source={section.body_md}
        className="tw-font-semibold tw-mb-2"
      />
      <ul className="tw-flex tw-flex-wrap tw-gap-2">
        {numbers.map((num) => {
          const label = EMERGENCY_LABELS[num][locale] ?? EMERGENCY_LABELS[num].fr;
          return (
            <li key={num}>
              <a
                href={EMERGENCY_TEL[num]}
                className="tw-inline-flex tw-items-center tw-px-3 tw-py-1.5 tw-rounded-full tw-bg-cal-emergency tw-text-white tw-text-[13px] tw-font-semibold hover:tw-opacity-90 tw-transition-opacity"
              >
                {label}
              </a>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
